function initProgressView(){
	//console.log("initProgressView()");

	$("angebot2-navigator").each(function(){
		initProgressViewLabel($(this).find(".formRowLabel"));		
	});
	if($("charterpaket2-navigator").length > 0){
		initProgressViewLabel($(this).find(".formRowLabel"));		
	}
}

function initProgressViewLabel($label){
	
	if(!$label){
		return;
	}

	if(!$label.hasClass("initialized")){

		$label.addClass("initialized");
		$label.click(function(){
			var $navigator = null;
			if($(this).closest("angebot2-navigator").length > 0){
				$navigator = $(this).closest("angebot2-navigator");
			}
			else{
				$navigator = $(this).closest("charterpaket2-navigator");
			}

			console.log("initProgressViewLabel() formRowLabel click!");
			console.log("initProgressViewLabel() $navigator:" + $navigator);

			if($navigator && $(window).width() < _breakpointMedium){
				var $progressView = $navigator.find(".progressView");
				$(this).toggleClass("opened");
				$progressView.toggleClass("opened");
			}
		});
	}
}